"use client";
import { useState, useEffect } from "react";
import {
  ChevronLeft,
  Check,
  ChevronDown,
  ChevronUp,
  Loader,
} from "lucide-react";
import styles from "./PricingPopup.module.css";
import ConfettiSection from "./ConfettiSection";
const Button = ({ className = "", disabled, ...props }) => (
  <button className={className} disabled={disabled} {...props} />
);
const Badge = ({ className = "", ...props }) => (
  <span className={className} {...props} />
);
const Switch = ({ checked, onCheckedChange, disabled, className = "" }) => (
  <input
    type="checkbox"
    role="switch"
    className={className}
    checked={!!checked}
    onChange={(e) => onCheckedChange?.(e.target.checked)}
    disabled={disabled}
  />
);
const plans = [
  {
    id: "starter",
    name: "Starter",
    icon: "https://rexptin.vercel.app/svg/starter-icon.svg",
    monthlyPrice: 119,
    yearlyPrice: 99,
    description: "Perfect for small workload in a startup or micro business",
    features: [
      "300 minutes / month",
      "FREE VoIP Number",
      "Agent Characterization",
    ],
    additionalFeatures: [
      "24/7 Availability",
      "Email Notifications",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Basic)",
      "Call Recording",
      "Intelligent Call Transfer(5)",
      "Intelligent Call Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Under 72 hrs) & AI Chat & Call Support",
    ],
    priceOverrides: [
      { countryCode: "USD", monthlyPrice: 119, yearlyPrice: 99 },
      { countryCode: "AUD", monthlyPrice: 179, yearlyPrice: 149.92 },
      { countryCode: "CAD", monthlyPrice: 159, yearlyPrice: 133.25 },
      { countryCode: "GBP", monthlyPrice: 89, yearlyPrice: 74 },
      { countryCode: "INR", monthlyPrice: 119, yearlyPrice: 99 },
    ],
    iconColor: "blue",
  },
  {
    id: "scaler",
    name: "Scaler",
    icon: "https://rexptin.vercel.app/svg/scaler-icon.svg",
    monthlyPrice: 299,
    yearlyPrice: 249,
    description: "For scaling small businesses to a professional level.",
    features: [
      "750 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
    ],
    additionalFeatures: [
      "Agent Characterization",
      "24/7 Availability",
      "Email Notifications",
      "SMS Notifications",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Basic)",
      "Call Recording",
      "Call Transcript",
      "Intelligent Call Transfer(5)",
      "Caller Sentiment Analysis",
      "Intelligent Call Analysis",
      "Lead Type Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Biz Hrs) & AI Chat & Call Support",
    ],
    priceOverrides: [
      { countryCode: "USD", monthlyPrice: 299, yearlyPrice: 249 },
      { countryCode: "AUD", monthlyPrice: 459, yearlyPrice: 383.25 },
      { countryCode: "CAD", monthlyPrice: 399, yearlyPrice: 333.25 },
      { countryCode: "GBP", monthlyPrice: 219, yearlyPrice: 183.25 },
      { countryCode: "INR", monthlyPrice: 299, yearlyPrice: 249 },
    ],
    iconColor: "green",
  },
  {
    id: "growth",
    name: "Growth",
    icon: "https://rexptin.vercel.app/svg/growth-icon.svg",
    monthlyPrice: 599,
    yearlyPrice: 499,
    description: "A workhorse to handle small to medium business needs.",
    features: [
      "1500 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
    ],
    additionalFeatures: [
      "Agent Characterization",
      "24/7 Availability",
      "Email Notifications",
      "SMS Notifications",
      "Website Widget Integration",
      "Speech Naturalization",
      "Environment Setup",
      "Calendar Integration using Cal.com",
      "Book Calendar Meetings",
      "Call History(Advanced)",
      "Call Recording",
      "Call Transcript",
      "Intelligent Call Transfer(10)",
      "Caller Sentiment Analysis",
      "Intelligent Call Analysis",
      "Lead Type Analysis",
      "Lead Nurturing",
      "Business Knowledge Training",
      "Product & Services Training",
      "Spam Protection",
      "Profanity Protection",
      "CRM Integration(Coming Soon)",
      "Own Voice Implementation(Coming Soon)",
      "Human Email(Biz Hrs) & AI Chat & Call Support",
    ],
    priceOverrides: [
      { countryCode: "USD", monthlyPrice: 599, yearlyPrice: 499 },
      { countryCode: "AUD", monthlyPrice: 919, yearlyPrice: 774.91 },
      { countryCode: "CAD", monthlyPrice: 819, yearlyPrice: 684.91 },
      { countryCode: "GBP", monthlyPrice: 439, yearlyPrice: 370.75 },
      { countryCode: "INR", monthlyPrice: 599, yearlyPrice: 499 },
    ],
    iconColor: "pink",
  },
  // {
  //   id: "corporate",
  //   name: "Corporate",
  //   icon: "https://rexptin.vercel.app/svg/corporate-icon.svg",
  //   monthlyPrice: 999,
  //   yearlyPrice: 799,
  //   description: "The ultimate workhorse that handles all large-volume needs",
  //   features: [
  //     "3000 minutes / month",
  //     "FREE VoIP Number",
  //     "Multi-Lingual with In-Call Language Switching",
  //   ],
  //   additionalFeatures: [
  //     "Agent Characterization",
  //     "24/7 Availability",
  //     "Email Notifications",
  //     "SMS Notifications",
  //     "Website Widget Integration",
  //     "Speech Naturalization",
  //     "Environment Setup",
  //     "Calendar Integration using Cal.com",
  //     "Book Calendar Meetings",
  //     "Call History(Advanced)",
  //     "Call Recording",
  //     "Call Transcript",
  //     "Intelligent Call Transfer(10)",
  //     "Caller Sentiment Analysis",
  //     "Intelligent Call Analysis",
  //     "Lead Type Analysis",
  //     "Lead Nurturing",
  //     "Business Knowledge Training",
  //     "Product & Services Training",
  //     "Spam Protection",
  //     "Profanity Protection",
  //     "CRM Integration(Coming Soon)",
  //     "Own Voice Implementation(Coming Soon)",
  //     "Human Email & Call-Back(Biz Hrs)",
  //     "Dedicated Account Manager",
  //     "Assisted Custom Agent Training",
  //   ],
  //   priceOverrides: [
  //     { countryCode: "USD", monthlyPrice: 999, yearlyPrice: 799 },
  //     { countryCode: "AUD", monthlyPrice: 1549, yearlyPrice: 1249.91 },
  //     { countryCode: "CAD", monthlyPrice: 1369, yearlyPrice: 1083.25 },
  //     { countryCode: "GBP", monthlyPrice: 739, yearlyPrice: 594.08 },
  //     { countryCode: "INR", monthlyPrice: 999, yearlyPrice: 799 },
  //   ],
  //   iconColor: "orange",
  // },
];

const planYearlyImageMap = {
  Starter: "/images/starter_yearly.svg",
  Scaler: "/images/scaler_yearly.svg",
  Growth: "/images/growth_yearly.svg",
  Corporate: "/images/corporate_yearly.svg",
};

export default function PricingPopup({
  isOpen,
  onClose,
  selectedPlanName,
  countryCode,
  isYearlys,
  discount = "30%",
}) {
  const [currentPlan, setCurrentPlan] = useState(0);
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const [userCountry, setUserCountry] = useState(countryCode);
  const [isYearly, setIsYearly] = useState(() =>
    countryCode === "US" ? isYearlys : false
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isFromPricingQuery, setIsFromPricingQuery] = useState(false);
  const [isCongratulationPopupVisible, setIsCongratulationPopupVisible] =
    useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (selectedPlanName) {
      const planIndex = plans.findIndex(
        (plan) => plan.name === selectedPlanName
      );
      setCurrentPlan(planIndex !== -1 ? planIndex : 0);
    } else {
      setCurrentPlan(0);
    }
  }, [selectedPlanName]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const fromQuery = localStorage.getItem("isFromPricingQuery") === "true";
      setIsFromPricingQuery(fromQuery);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      setIsCongratulationPopupVisible(true);
      setIsFadingOut(false);

      const fadeTimeout = setTimeout(() => setIsFadingOut(true), 7000);
      const removeTimeout = setTimeout(
        () => setIsCongratulationPopupVisible(false),
        9000
      );

      return () => {
        clearTimeout(fadeTimeout);
        clearTimeout(removeTimeout);
      };
    }
  }, [isOpen]);

  const countryToCurrencyMap = {
    IN: "INR",
    US: "USD",
    AU: "AUD",
    CA: "CAD",
    GB: "GBP",
  };

  const selectedPlan = plans[currentPlan];

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const toggleFeatures = () => setShowAllFeatures((v) => !v);

  const handleClose = () => {
    onClose?.();
    document.body.style.overflow = "unset";
  };

  const getPlanPrice = (plan, isYearlyFlag, countryCodeFlag) => {
    const currencyCode = countryCodeFlag
      ? countryToCurrencyMap[countryCodeFlag]
      : "USD";
    const override = plan.priceOverrides?.find(
      (p) => p.countryCode === currencyCode
    );
    return override
      ? isYearlyFlag
        ? override.yearlyPrice
        : override.monthlyPrice
      : isYearlyFlag
      ? plan.yearlyPrice
      : plan.monthlyPrice;
  };

  const currentPrice = getPlanPrice(selectedPlan, isYearly, userCountry);
  const currencySymbols = {
    USD: "$",
    INR: "$",
    GBP: "£",
    CAD: "$",
    AUD: "$",
  };
  const currencyCode = userCountry ? countryToCurrencyMap[userCountry] : "USD";
  const currency = currencySymbols[currencyCode] || "$";

  // const yearlyPromoMap = {
  //   Corporate: "promo_1SOBtESCQQfKS3WDqucaTnNI",
  //   Growth: "promo_1SOBrJSCQQfKS3WD1vNCdYCf ",
  //   Scaler: "promo_1SOBuaSCQQfKS3WDq1KdMjnZ",
  //   Starter: "promo_1SOBnbSCQQfKS3WDTMoqIDkX ",
  // };

    const yearlyPromoMap = {
    Growth: "promo_1SYLo0SCQQfKS3WD1Y96Iq5W",
    Scaler: "promo_1SYLgfSCQQfKS3WDTswRUm41",
    Starter: "promo_1SYLIYSCQQfKS3WDxGa8SRK3",
  };


  async function handleGetStarted(planTitle) {
    setIsLoading(true);
    const interval = isYearly ? "year" : "month";

    // let promoCode = "promo_1SOBw4SCQQfKS3WDhNavoVbN";
    let promoCode = "promo_1SYLthSCQQfKS3WDa62nl2Y3";
    if (isYearly) promoCode = yearlyPromoMap[planTitle] || promoCode;

    const requestBody = {
      planName: planTitle,
      interval,
      ...(promoCode ? { promotionCode: promoCode } : {}),
    };

    try {
      const response = await fetch(
        "https://srvr.rxpt.ai/api/create-checkout-session-url",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "*/*" },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (response.ok && data?.url) {
        window.open(data.url, "_blank");
        onClose?.();
      } else {
        console.error(
          "Failed to create checkout session:",
          data?.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error creating checkout session:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleFreeTrialClick = () => {
    window.open("https://app.rxpt.ai?isUser=free", "_blank");
  };

  const totalDisocuntPrice = [
    {
      planName: "Starter",
      discountPrice: {
        US: "$1,098.00",
        AU: "$1,454.00",
        CA: "$1,299.00",
        GB: "£723.00",
        IN: "$1,098.00",
      },
    },
    {
      planName: "Scaler",
      discountPrice: {
        US: "$2,763.00",
        AU: "$4,252.50",
        CA: "$3,697.95",
        GB: "£2,033.40",
        IN: "$2,763.00",
      },
    },
    {
      planName: "Growth",
      discountPrice: {
        US: "$5,538.00",
        AU: "$8,600.60",
        CA: "$7,601.60",
        GB: "£4,114.65",
        IN: "$5,538.00",
      },
    },
    {
      planName: "Corporate",
      discountPrice: {
        US: "$8,888.00",
        AU: "$13,904.20",
        CA: "$12,049.80",
        GB: "£6,608.90",
        IN: "$8,888.00",
      },
    },
  ];

  const totalYearlyOff = [
    {
      planName: "Starter",
      OffPrice: {
        US: "$90.00",
        AU: "$345.00",
        CA: "$300.00",
        GB: "£165.00",
        IN: "$90.00",
      },
    },
    {
      planName: "Scaler",
      OffPrice: {
        US: "$225.00",
        AU: "$346.50",
        CA: "$301.05",
        GB: "£165.60",
        IN: "$225.00",
      },
    },
    {
      planName: "Growth",
      OffPrice: {
        US: "$450.00",
        AU: "$698.40",
        CA: "$617.40",
        GB: "£334.35",
        IN: "$450.00",
      },
    },
    {
      planName: "Corporate",
      OffPrice: {
        US: "$700.00",
        AU: "$1,094.80",
        CA: "$949.20",
        GB: "£520.10",
        IN: "$700.00",
      },
    },
  ];

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay}>
          {isCongratulationPopupVisible && (
            <div className={isFadingOut ? styles.confettiFadeOut : ""}>
              <ConfettiSection />
            </div>
          )}

          <div className={styles.modalContainer}>
            <div className={styles.header}>
              <div
                className={styles.headerLeft}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <button className={styles.backButton}>
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <h2 className={styles.headerTitle}>Back</h2>
              </div>
              <Badge
                variant="secondary"
                className={styles.trialBadge}
                onClick={handleFreeTrialClick}
                style={{ cursor: "pointer" }}
              >
                FREE TRIAL
              </Badge>
            </div>

            <div className={styles.scrollableContent}>
              <div className={styles.planCardContainer}>
                <div
                  className={`${styles.planCard} ${
                    styles[
                      `planCard${
                        selectedPlan.iconColor.charAt(0).toUpperCase() +
                        selectedPlan.iconColor.slice(1)
                      }`
                    ]
                  }`}
                >
                  <div className={styles.TopPlansOffer}>
                    <div>
                      <div className={styles.priceSection}>
                        <div className={styles.iconContainer}>
                          <img src={selectedPlan.icon} alt="" />
                        </div>
                        <div>
                          <div className={styles.priceText}>
                            <span
                              style={{
                                textDecorationLine: "line-through",
                                textDecorationColor: "red",
                                textDecorationThickness: "2px",
                                color: "red",
                              }}
                            >
                              {currency}
                              {currentPrice.toLocaleString()}/m
                            </span>
                            <span
                              className={`${styles.priceText} dark: text-black`}
                            >
                              {currency}
                              {isYearly
                                ? (() => {
                                    const discountEntry =
                                      totalDisocuntPrice.find(
                                        (entry) =>
                                          entry.planName === selectedPlan.name
                                      );
                                    const discountedYearlyStr =
                                      discountEntry?.discountPrice?.[
                                        userCountry
                                      ] ??
                                      discountEntry?.discountPrice?.["US"] ??
                                      "0";
                                    const numericYearly = parseFloat(
                                      discountedYearlyStr.replace(
                                        /[^0-9.]/g,
                                        ""
                                      )
                                    );
                                    return (numericYearly / 12).toFixed(2);
                                  })()
                                : (currentPrice * 0.7).toFixed(2)}
                              /m
                            </span>
                            {isYearly && (
                              <span className={styles.smtext}>
                                (effective monthly price)
                              </span>
                            )}
                            {!isYearly && (
                              <p className={styles.smtext}>
                                (For the first 2 months only)
                              </p>
                            )}
                          </div>

                          {isYearly &&
                            (() => {
                              const originalYearlyPrice = Math.round(
                                getPlanPrice(selectedPlan, true, userCountry) *
                                  12
                              );
                              const discountEntry = totalDisocuntPrice.find(
                                (entry) => entry.planName === selectedPlan.name
                              );
                              const discountedPriceString =
                                discountEntry?.discountPrice?.[userCountry] ??
                                discountEntry?.discountPrice?.["US"];
                              const currencySymbol =
                                discountedPriceString?.match(
                                  /[^\d.,\s]+/g
                                )?.[0] || currency;

                              return (
                                <div className={styles.billingText}>
                                  Save{" "}
                                  {(
                                    ((getPlanPrice(
                                      selectedPlan,
                                      false,
                                      userCountry
                                    ) -
                                      getPlanPrice(
                                        selectedPlan,
                                        true,
                                        userCountry
                                      )) /
                                      getPlanPrice(
                                        selectedPlan,
                                        false,
                                        userCountry
                                      )) *
                                    100
                                  ).toFixed(0)}
                                  % — Total:{" "}
                                  <span
                                    style={{
                                      textDecorationLine: "line-through",
                                      textDecorationColor: "red",
                                      textDecorationThickness: "2px",
                                      color: "red",
                                    }}
                                  >
                                    {currencySymbol}
                                    {originalYearlyPrice.toLocaleString()}
                                  </span>
                                  <span className="font-semibold">
                                    {discountedPriceString}
                                  </span>
                                  /year
                                </div>
                              );
                            })()}
                        </div>
                      </div>

                      <h3 className={styles.planTitle}>{selectedPlan.name}</h3>
                      <p className={styles.planDescription}>
                        {selectedPlan.description}
                      </p>
                    </div>

                    {/* <div className={styles.LaunchOffer}>
                      <img src="./Images/Launch-Offer.svg" alt="Launch-Offer" />
                      <p>Valid Till 30th November</p>
                    </div> */}

                    <div className={styles.LaunchOffer}>
                      <img
                        src="./Images/thanksgiving-Icon.svg"
                        alt="Launch-Offer"
                      />
                      {/* <p>Valid Till 2nd December</p> */}
                    </div>

                    {isYearly && userCountry === "US" && (
                      <div className={styles.LaunchOffer}>
                        {/* <img
                          src={
                            planYearlyImageMap[selectedPlan.name] ??
                            "/Images/Launch-Offer.svg"
                          }
                          alt={`${selectedPlan.name} Launch Offer`}
                        />
                        <p>Valid Till 30th November</p> */}

                        <img
                          src="./Images/thanksgiving-Icon.svg"
                          alt="Launch-Offer"
                        />
                        {/* <p>Valid Till 2nd December</p> */}
                      </div>
                    )}
                  </div>

                  <div
                    className={`${styles.featuresList} ${
                      showAllFeatures ? styles.featuresListExpanded : ""
                    }`}
                  >
                    {selectedPlan.features.map((feature, index) => (
                      <div key={index} className={styles.featureItem}>
                        <div className={styles.featureIcon}>
                          <Check className="w-3 h-3 text-white" />
                        </div>
                        <span className={styles.featureText}>{feature}</span>
                      </div>
                    ))}
                    {showAllFeatures &&
                      selectedPlan.additionalFeatures.map((feature, index) => (
                        <div
                          key={`additional-${index}`}
                          className={styles.featureItem}
                        >
                          <div className={styles.featureIcon}>
                            <Check className="w-3 h-3 text-white" />
                          </div>
                          <span className={styles.featureText}>{feature}</span>
                        </div>
                      ))}
                  </div>

                  <button
                    className={styles.seeAllButton}
                    onClick={toggleFeatures}
                  >
                    {showAllFeatures ? (
                      <>
                        <ChevronUp className="w-4 h-4 mr-1" />
                        Hide Features
                      </>
                    ) : (
                      <>
                        <ChevronDown className="w-4 h-4 mr-1" />
                        See All Features (
                        {selectedPlan.additionalFeatures.length} more)
                      </>
                    )}
                  </button>

                  <div className={styles.billingToggle}>
                    <span
                      className={`${styles.toggleLabel} ${
                        !isYearly ? styles.toggleLabelActive : ""
                      }`}
                      onClick={() => setIsYearly(false)}
                    >
                      Monthly
                    </span>

                    <div
                      className={`${styles.switch} ${
                        isYearly ? styles.active : ""
                      }`}
                      onClick={() => setIsYearly(!isYearly)}
                    >
                      <div className={styles.circle}></div>
                    </div>

                    <span
                      className={`${styles.toggleLabel} ${
                        isYearly ? styles.toggleLabelActive : ""
                      }`}
                      onClick={() => setIsYearly(true)}
                    >
                      Yearly
                    </span>
                  </div>

                  <Button
                    className={styles.subscribeButton}
                    onClick={() => handleGetStarted(selectedPlan.name)}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <Loader className="w-4 h-4 animate-spin mr-2" />{" "}
                        Processing...
                      </>
                    ) : isYearly ? (
                      (() => {
                        const discountEntry = totalDisocuntPrice.find(
                          (entry) => entry.planName === selectedPlan.name
                        );
                        const discountedYearly =
                          discountEntry?.discountPrice?.[userCountry] ??
                          discountEntry?.discountPrice?.["US"] ??
                          "N/A";
                        return `Subscribe For ${discountedYearly}/Year`;
                      })()
                    ) : (
                      `Subscribe For ${currency}${(currentPrice * 0.7).toFixed(
                        2
                      )}/Month`
                    )}
                  </Button>

                  {isYearly && (
                    <div
                      className={styles.billingText2}
                      style={{ textAlign: "center" }}
                    >
                      <p>
                        With current LAUNCH OFFER, We are giving additional{" "}
                        <strong>
                          {(() => {
                            const offEntry = totalYearlyOff.find(
                              (entry) => entry.planName === selectedPlan.name
                            );
                            const offAmount =
                              offEntry?.OffPrice?.[userCountry] ??
                              offEntry?.OffPrice?.["US"] ??
                              "$0.00";
                            return `"${offAmount}"` + "Off";
                          })()}
                        </strong>{" "}
                        which makes effective monthly price to{" "}
                        <strong>
                          {(() => {
                            const discountEntry = totalDisocuntPrice.find(
                              (entry) => entry.planName === selectedPlan.name
                            );
                            const discountedYearlyStr =
                              discountEntry?.discountPrice?.[userCountry] ??
                              discountEntry?.discountPrice?.["US"] ??
                              "0";
                            const currencySymbol =
                              discountedYearlyStr?.match(/[^\d.,\s]+/g)?.[0] ||
                              currency;
                            const numericYearly = parseFloat(
                              discountedYearlyStr.replace(/[^0-9.]/g, "")
                            );
                            const effectiveMonthly = (
                              numericYearly / 12
                            ).toFixed(2);
                            return `${currencySymbol}${effectiveMonthly}/m`;
                          })()}{" "}
                        </strong>
                        {(() => {
                          const discountEntry = totalDisocuntPrice.find(
                            (entry) => entry.planName === selectedPlan.name
                          );
                          const discountedYearly =
                            discountEntry?.discountPrice?.[userCountry] ??
                            discountEntry?.discountPrice?.["US"] ??
                            "N/A";
                          return (
                            <>
                              {" "}
                              for 1st year or{" "}
                              <strong> {discountedYearly}/year. </strong>
                            </>
                          );
                        })()}
                        Then it will be{" "}
                        <strong>
                          {currency}
                          {Math.round(
                            getPlanPrice(selectedPlan, true, userCountry) * 12
                          ).toLocaleString()}{" "}
                        </strong>
                        per year after offer completes.
                      </p>
                    </div>
                  )}

                  {!isYearly && (
                    <div
                      className={styles.billingText2}
                      style={{ textAlign: "center" }}
                    >
                      {/* <p>
                        With current<strong> LAUNCH OFFER</strong>, We are
                        giving <strong>30% off</strong> on monthly packages for
                        the 1st 3 months. Then it will be{" "}
                        <strong>
                          {currency}
                          {currentPrice.toLocaleString()}{" "}
                        </strong>{" "}
                        per month after offer completes.
                      </p> */}
                       <p>
                        With current<strong> Holiday Week OFF</strong>, We are
                        giving <strong>30% off</strong> on monthly packages for
                        the 1st 2 months. Then it will be{" "}
                        <strong>
                          {currency}
                          {currentPrice.toLocaleString()}{" "}
                        </strong>{" "}
                        per month after offer completes.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.planSelection}>
              <div className={styles.planOptions}>
                {plans.map((plan, index) => (
                  <div
                    key={plan.id}
                    className={`${styles.planOption} ${
                      currentPlan === index
                        ? styles[
                            `planOptionActive${
                              plan.iconColor.charAt(0).toUpperCase() +
                              plan.iconColor.slice(1)
                            }`
                          ]
                        : ""
                    }`}
                    onClick={() => {
                      setCurrentPlan(index);
                      setShowAllFeatures(false);
                    }}
                  >
                    <div className={styles.radioContainer}>
                      <div
                        className={`${styles.radioButton} ${
                          currentPlan === index
                            ? styles.radioButtonActive
                            : styles.radioButtonInactive
                        }`}
                      >
                        {currentPlan === index && (
                          <div className={styles.radioButtonDot} />
                        )}
                      </div>
                    </div>

                    <div
                      className={`${styles.planIconContainer} ${
                        currentPlan === index
                          ? styles.planIconContainerActive
                          : styles.planIconContainerInactive
                      }`}
                    >
                      <div
                        className={`${styles.planIcon} ${
                          currentPlan === index
                            ? styles.planIconActive
                            : styles[
                                `planIcon${
                                  plan.iconColor.charAt(0).toUpperCase() +
                                  plan.iconColor.slice(1)
                                }`
                              ]
                        }`}
                      >
                        <img src={plan.icon} alt="" />
                      </div>
                    </div>

                    <div className={styles.planInfo}>
                      <div
                        className={`${styles.planName} ${
                          currentPlan === index
                            ? styles.planNameActive
                            : styles.planNameInactive
                        }`}
                      >
                        {plan.name}
                      </div>
                      <div className={styles.planPriceSmall}>
                        from {currency}
                        {getPlanPrice(
                          plan,
                          isYearly,
                          userCountry
                        ).toLocaleString()}
                        /m
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
